<div class="col-lg-12 head-tit">
    <h1 class="preline_title" [innerHTML]="titleTxt"></h1>
</div>   

